import { createActions } from 'redux-actions';

import { PolicyCommissionInvoiceList, PolicyCommissionInvoice } from '@models/PolicyCommissionInvoice';
import { GetAllPolicyCommissionInvoiceParams, CreatePolicyCommissionInvoiceParams, GetPolicyCommissionInvoiceParams, UpdatePolicyCommissionInvoiceParams } from '@apis/PolicyCommissionInvoiceApi';
import { Pagination } from '@models/Pagination';

export type State = {
  invoices?: PolicyCommissionInvoiceList[] | null;
  invoice?: PolicyCommissionInvoice | null;
  pagination?: Pagination;
  isLoading: boolean;
  isReload: boolean;
};

export type PolicyCommissionInvoicesFetchPayload = GetAllPolicyCommissionInvoiceParams;
export type PolicyCommissionInvoiceCreatePayload = CreatePolicyCommissionInvoiceParams;
export type PolicyCommissionInvoiceFetchPayload = GetPolicyCommissionInvoiceParams;
export type PolicyCommissionInvoiceUpdatePayload = UpdatePolicyCommissionInvoiceParams;
export type StateUpdatePayload = Partial<State>;

export const {
  policyCommissionInvoicesFetch,
  policyCommissionInvoiceCreate,
  policyCommissionInvoiceFetch,
  policyCommissionInvoiceUpdate,
  stateUpdate,
  stateClear,
  stateReload,
} = createActions(
  'POLICY_COMMISSION_INVOICES_FETCH',
  'POLICY_COMMISSION_INVOICE_CREATE',
  'POLICY_COMMISSION_INVOICE_FETCH',
  'POLICY_COMMISSION_INVOICE_UPDATE',
  'STATE_UPDATE',
  'STATE_CLEAR',
  'STATE_RELOAD',
  {
    prefix: 'FEATURE_POLICY_COMMISSION_INVOICE',
  },
);
